import React, { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

import Spinner from "./components/spinner/Spinner";
import NewUserForm from './components/users/NewUserForm';
import Dashboard from "./components/navigation/Dashboard";
import { getUserFromDb} from './store/localDb';
import { setUserStateLoaded, getCurrentUserId, getUserStateLoaded, resetAllLoaded, userState, setTestMode, setDemoMode, getStateScope, getAppState, useAppStateSnapshot, setCurrentUserId } from './store/storeValtio';
import { loadDataFromDb } from "helpers/generalHelpers";
import Development from "components/settings/Development";
import LoadUserData from "components/users/LoadUserData";
import HelpModal from "components/help/HelpModal";
import ClearData from "components/settings/ClearData";
import UseAppModal from "components/common/UseAppModal";

export const AppVersionFixed = "0.06"

export default function App() {
  const localCurrentUser = localStorage.getItem("currentUser");
  setCurrentUserId(localCurrentUser);
  const currentUserId = getCurrentUserId();
  console.log("App local currentUser: ", localCurrentUser, currentUserId);

  //console.log('App', window.location.href);
  const appState = useAppStateSnapshot();
  //console.log('appState', appState);

  // useMemo(() => {
  //     //console.log('UE route',location.pathname)
  // }, [location])

  useMemo(() => {
    //const userId = localStorage.getItem("currentUser");
    console.log("App UE: ", localCurrentUser);

    const testUsers = [
      'james@percentage.com',
      'charise@percentage.com',
      'jimmy@john.com'
    ];

    async function getUser() {
      //console.log('App UE getUser', userId);
      if (localCurrentUser) {
        let response = await getUserFromDb(localCurrentUser);
        let result = await response;
        //console.log('App UE result:', result);
        if (!result) {
          localStorage.removeItem("currentUser");
          //console.log("No user in DB, local user cleared");
          setUserStateLoaded(false);
        } else {
          resetAllLoaded(false);
          
          // set demo/test mode
          const ue = userState.currentUser.email.toLowerCase();
          const scope = getStateScope();
          const tester = testUsers.indexOf(ue) >= 0;
          const apptest = scope ? scope.includes('apptest.') : false;
          console.log('test mode', tester, ue);
          setTestMode(tester || apptest);
          setDemoMode(ue ==='demo@demo.com');
        }
      }
      //console.log('App UE getUser done');
    };

    let usl = getUserStateLoaded();
    //console.log("App currentUser: ", localCurrentUser, usl);
    if (localCurrentUser && !usl) getUser();
    usl = getUserStateLoaded();
    //console.log('App UE finished', usl);
  },[localCurrentUser])

  // const location = useLocation();
  // const route = location.pathname;
  // console.log('route', route)
  // if (route === '/development') return <Development />;
  // if (route === '/loaduserdata') return <LoadUserData />;
  // if (route === '/cleardata') return <ClearData />;

  const ua = appState.installed && !appState.standalone;
  //const ua = true;  // for testing
  //console.log('ua', ua, appState.installed, appState.standalone);
  if (ua) return (
    <div>
      <UseAppModal open={ua} />
    </div>
  );
  
  if (!localCurrentUser) return (
    <div>
      <HelpModal forWhat={'NewUser'} />
      <NewUserForm />
    </div>
  );
  
  //getUsersFromDb();
  const userId = getCurrentUserId();
  console.log("App UserId: ", userId);

  loadDataFromDb(userId);

  if (!getUserStateLoaded()) {
    //console.log('User Not Loaded');
    return (<Spinner />);
  }

  return (
    <div>
      <Dashboard />
    </div>
  );
}
